import { Box } from '@bechtel/gds';
import styled from 'styled-components';
import { listWidth, smallScreenListWidth } from '~/components/organisms/weld-search-drawer';

export const WeldContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: 100vh;
  position: absolute;
`;

export const WeldDetailContainer = styled.div`
  position: absolute;
  left: ${listWidth};
  overflow-y: hidden;
  height: 100vh;
  width: calc(100% - ${listWidth});
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
    width: calc(100% - ${smallScreenListWidth});
  }
`;
